export default {
  data() {
    return { isMobile: window.innerWidth < 1024 };
  },
  computed: {
    rowsPerPage() {
      return this.isMobile ? 8 : 10;
    }
  },
  methods: {
    updateIsMobile() {
      this.isMobile = window.innerWidth < 1024;
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateIsMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateIsMobile);
  }
};
